import Vue from 'vue'
import {ifElementExistsThenLaunch} from './functions/dom';
import {alertsController} from './alerts-controller';
import {w} from './cltvo/constants';
// import {applicationSelectContainer}from './application-select-container';
import {homeSlider}from './slider-home';
import {shippingSlider}from './slider-shipping';
import {navside}	from './navside';
import {positionHeader} from './menu-fixed';
import {front} from './vue/main/front';
import {cart} from './vue/main/cart';
import {confirmation} from './vue/main/confirmation';
import {checkout} from './vue/main/checkout';
import {billing} from './vue/main/billing';

import {singleApplicationVue} from './vue/main/single-application';
import {setsApplicationVue} from './vue/main/sets-application';
import {mainVue} from './vue/main-vue';
import {scroll}	from	'./scroll-top';
import {applicationSlide} from './vue/components/application-slide';
import MenuCart from './vue/components/menu-cart.vue';
import {clickList} from './hidden-list';
import {modalNewsletter, popupGeneral} from './modal-newsletter';

import {
	addressModalCreate,
	addressModalEdit,
	address,
} from './vue/components/simple-cruds-client';

import StickerConfig from './vue/components/sticker-config.vue'
import StickerMessagePreview from './vue/components/sticker-message-preview.vue'
import { cookies } from './cookies';
import { menuBanner } from './menu-banner';
import { previsualizador_movil } from './previsualizador';
Vue.component('menu-cart', MenuCart)


w.on('load', () => {

	ifElementExistsThenLaunch([
		['#main-vue', mainVue, undefined, [front, {}]],
		['#cart-vue', mainVue, undefined, [cart, {}]],
		['#confirmation-vue', mainVue, undefined, [confirmation, {}]],
		['#checkout-vue', mainVue, undefined, [checkout, {}]],
		['#billing-vue', mainVue, undefined, [billing, {}]],
		['#front-vue', mainVue, undefined, [front, {
			addressModalCreate,
			addressModalEdit,
			address,
			applicationSlide,
		}]],
		['#single-application-vue', mainVue, undefined, [singleApplicationVue, {}]],
		['#sets-application-vue', mainVue, undefined, [setsApplicationVue, {}]],
		['#alert__container', alertsController, 'init', []],
	]);

	navside();
	positionHeader();

	clickList();
	modalNewsletter();
	popupGeneral();

	cookies();

	menuBanner();

	if( w.width() <= 992 ){
		previsualizador_movil();
	}
});

//cosas relacionaDropdas únicamente con la version de desarrollo
if (process.env.NODE_ENV ==='webpack') { window.CLTVO_ENV = 'webpack'} //corre en modo webpack, necesario para hacer HMR
if (module.hot) { module.hot.accept(); }//permite hacer Hot Module Replacement



// WEBPACK FOOTER //
// ./resources/assets/js/micorriza.js